
/* -------------------------------------

	Modal

------------------------------------- */

$(document).ready(function() {


	/* datepicker */
	$('.modal .datepicker input').glDatePicker({

	    showAlways: false,
	    cssName: 'default dark',
	    zIndex: 1200,
	    width:320,

	    onClick: function(target, cell, date, data) {

	    	var day = (date.getDate() < 10) ? '0' + date.getDate() : date.getDate();
	    	var month = (date.getMonth()+1 < 10) ? '0' + (date.getMonth()+1) : (date.getMonth()+1);
	    	var date = day + '/' + month + '/' + date.getFullYear();

	        target.val(date);

	    }

	}).on('focus', function() {

		var input = $(this);
		var position = input.offset();

		$('div.gldp-default').css({

			'top': (position.top + input.outerHeight() + 1),
			'left': position.left,

		});

	});


});

